import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Box, Typography, Button, Paper, Stack } from "@mui/material";
import { House } from "lucide-react";
import { palette } from "@powerdiary/components-library/lib";
import { ROUTES } from "../../../routes";
import { useClientPortalConfigContext } from "context/ClientPortalConfig.ctx";
import Content from "../../Layout/Content";

export const AccessDenied = () => {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Access Denied - Client Bookings Zanda";
    }, []);

    const navigateHome = () => {
        void navigate(`/clientportal/${clientPortalGuid}/${ROUTES.HOME.urlPath}`);
    };

    return (
        <Content dataTestIdSuffix="access_denied" sx={{ alignSelf: "center" }}>
            <Box display="flex" justifyContent="center" padding={3}>
                <Paper>
                    <Stack spacing={3} p={4} alignItems="center">
                        <Box display="flex" flexDirection="column" gap={1}>
                            <Typography variant="heading3" textAlign="center" data-test-id="text_error_title">
                                Access denied
                            </Typography>
                            <Typography
                                variant="paragraphMediumRegular"
                                textAlign="center"
                                data-test-id="text_error_subtitle"
                            >
                                You don&apos;t have access to view the page
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                background: palette.neutral[50],
                                borderRadius: 1,
                                padding: 2,
                            }}
                            data-test-id="section_error_instructions"
                        >
                            <Typography variant="paragraphMediumBold" data-test-id="text_instructions_title">
                                What can you do?
                            </Typography>
                            <ul style={{ margin: 0 }}>
                                <li>
                                    <Typography
                                        variant="paragraphMediumRegular"
                                        data-test-id="text_instruction_logging"
                                    >
                                        Please try logging in to view the page you&apos;re looking for.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography
                                        variant="paragraphMediumRegular"
                                        data-test-id="text_instruction_contact"
                                    >
                                        If you&apos;re still having trouble, contact your practice directly for help.
                                    </Typography>
                                </li>
                            </ul>
                        </Box>

                        <Button
                            variant="contained"
                            startIcon={<House size={14} strokeWidth={2} aria-hidden />}
                            onClick={navigateHome}
                            data-test-id="button_home"
                        >
                            Home
                        </Button>
                    </Stack>
                </Paper>
            </Box>
        </Content>
    );
};
